<template>
  <!-- <div :key="key" class="admin-layout"> -->
  <div class="admin-layout" :class="{'has-status-banner': hasBlock && hasBlock.isActive}">
    <StatusBanner :is-admin="true" />
    <Navbar />
    <router-view />
    <Sidebar
      v-if="sidebarName"
      :component-name="sidebarName"
      :component-styles="componentStyles"
      :sidebar-styles="sidebarStyles"
      :sidebar-position="sidebarPosition"
      :component-data="componentData"
    />
  </div>
</template>

<script>
import Navbar from '@/views/Admin/NavbarAdmin'
import Sidebar from '@/components/Sidebar'
import StatusBanner from '@/components/StatusBanner'
import {mapState} from 'vuex'

export default {
  name: 'adminLayout',
  components: {
    Navbar,
    Sidebar,
    StatusBanner
  },
  data: () => ({
    sidebarName: null,
    sidebarStyles: null,
    sidebarRotation: 'right',
    componentStyles: null,
    animationName: 'sidebar',
    componentData: null,
    key: 0
  }),
  computed: {
    ...mapState({
      hasBlock: s => s.operationStatus.hasBlock
    })
  },
  watch: {
    sidebarName(name) {
      if (name) {
        this._savedScrollY = window.scrollY
        document.body.style.overflow = 'hidden'
        document.body.style.position = ''
        document.body.style.top = ''
      } else {
        document.body.style.overflow = ''
        document.body.style.position = ''
        document.body.style.top = ''
        window.scrollTo(0, this._savedScrollY || 0)
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.$root.$on('ShowSidebar', params => {
      setTimeout(() => {
        if (params === null) {
          this.sidebarName = params
        } else if (typeof params === 'string') {
          this.sidebarName = params
          this.componentData = null
        } else if (typeof params === 'object') {
          this.sidebarName = params.sidebarName
          this.sidebarStyles = params.sidebarStyles
          this.componentStyles = params.componentStyles
          this.componentData = params.componentData
          this.animationName = !params.animationName ? 'sidebar' : params.animationName
        }
        this.sidebarPosition = !params?.sidebarPosition ? 'right' : params.sidebarPosition
      }, 0)
      this.key += 1
    })
  }
}
</script>
